module.exports = __webpack_public_path__ + "static/media/freedom_hall_of_fame.c175a16c.jpg";